import styled from 'styled-components';
import { Tap } from './dooh-react-utils';

const Button = styled(Tap)`
  width: 520px;
  color: black;
  background: #ffd82b;
  margin: 0 auto;
  font-size: 42px;
  font-family: RalewayBold, sans-serif;
  border: 3px solid black;
  height: 120px;
  border-radius: 60px;
  text-transform: uppercase;
  font-weight: 700;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  &.white {
    background: white;
  }
`;

export default Button;
